import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _styleVariables$color;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// ─── Status color palette ─────────────────────────────────────────────────────
var STATUS_STYLE = {
  '5': {
    dot: '#FA8C16',
    activeBg: '#FFF7E6',
    activeBorder: '#FFD591',
    activeColor: '#FA8C16'
  },
  '6': {
    dot: '#1A5AFF',
    activeBg: '#E6F2FF',
    activeBorder: '#1A5AFF',
    activeColor: '#1A5AFF'
  },
  '7': {
    dot: '#9254DE',
    activeBg: '#F9F0FF',
    activeBorder: '#B37FEB',
    activeColor: '#9254DE'
  },
  '8': {
    dot: '#3A8814',
    activeBg: '#E8FCD5',
    activeBorder: '#52C41A',
    activeColor: '#3A8814'
  }
};
var FALLBACK_STYLE = {
  dot: styleVariables.colors.blue2,
  activeBg: styleVariables.colors.blue1,
  activeBorder: styleVariables.colors.blue3,
  activeColor: styleVariables.colors.blue3
}; // ─── Styled components ────────────────────────────────────────────────────────

var StyledWrapper = styled.div.withConfig({
  displayName: "filter-boardcomponent__StyledWrapper",
  componentId: "sc-fjzdod-0"
})(["position:relative;display:inline-block;"]);
var StyledTrigger = styled.button.withConfig({
  displayName: "filter-boardcomponent__StyledTrigger",
  componentId: "sc-fjzdod-1"
})(["display:inline-flex;align-items:center;gap:8px;height:50px;padding:0 16px;border-radius:10px;border:1.5px solid ", ";background:", ";color:", ";font-size:13px;font-weight:", ";cursor:pointer;white-space:nowrap;user-select:none;transition:all 0.15s ease;&:hover{border-color:", ";color:", ";background:", ";}"], function (_ref) {
  var $active = _ref.$active;
  return $active ? styleVariables.colors.blue3 : styleVariables.colors.grey14;
}, function (_ref2) {
  var $active = _ref2.$active;
  return $active ? styleVariables.colors.blue1 : '#ffffff';
}, function (_ref3) {
  var $active = _ref3.$active;
  return $active ? styleVariables.colors.blue3 : styleVariables.colors.grey100;
}, function (_ref4) {
  var $active = _ref4.$active;
  return $active ? 600 : 400;
}, styleVariables.colors.blue3, styleVariables.colors.blue3, styleVariables.colors.blue1);
var StyledBadge = styled.span.withConfig({
  displayName: "filter-boardcomponent__StyledBadge",
  componentId: "sc-fjzdod-2"
})(["display:inline-flex;align-items:center;justify-content:center;min-width:18px;height:18px;padding:0 5px;border-radius:9px;background:", ";color:#ffffff;font-size:11px;font-weight:700;line-height:1;"], styleVariables.colors.blue3);
/* ── Panel ── */

var StyledPanel = styled.div.withConfig({
  displayName: "filter-boardcomponent__StyledPanel",
  componentId: "sc-fjzdod-3"
})(["position:absolute;top:calc(100% + 8px);right:0;z-index:1001;width:300px;background:#ffffff;border:1px solid ", ";border-radius:12px;box-shadow:0 8px 32px rgba(0,0,0,0.12);display:flex;flex-direction:column;overflow:hidden;"], styleVariables.colors.grey14);
var StyledPanelHeader = styled.div.withConfig({
  displayName: "filter-boardcomponent__StyledPanelHeader",
  componentId: "sc-fjzdod-4"
})(["display:flex;align-items:center;justify-content:space-between;padding:14px 16px 12px;border-bottom:1px solid ", ";"], styleVariables.colors.grey14);
var StyledPanelTitle = styled.span.withConfig({
  displayName: "filter-boardcomponent__StyledPanelTitle",
  componentId: "sc-fjzdod-5"
})(["font-size:14px;font-weight:700;color:", ";letter-spacing:0.01em;"], styleVariables.colors.grey100);
var StyledCloseBtn = styled.button.withConfig({
  displayName: "filter-boardcomponent__StyledCloseBtn",
  componentId: "sc-fjzdod-6"
})(["width:28px;height:28px;display:inline-flex;align-items:center;justify-content:center;border:none;background:transparent;cursor:pointer;color:", ";border-radius:6px;transition:background 0.12s ease;&:hover{background:", ";color:", ";}"], styleVariables.colors.gray11, styleVariables.colors.grey14, styleVariables.colors.grey100);
var StyledPanelBody = styled.div.withConfig({
  displayName: "filter-boardcomponent__StyledPanelBody",
  componentId: "sc-fjzdod-7"
})(["flex:1;overflow-y:auto;padding:4px 0 8px;"]);
var StyledSection = styled.div.withConfig({
  displayName: "filter-boardcomponent__StyledSection",
  componentId: "sc-fjzdod-8"
})(["padding:12px 16px 4px;"]);
var StyledSectionLabel = styled.div.withConfig({
  displayName: "filter-boardcomponent__StyledSectionLabel",
  componentId: "sc-fjzdod-9"
})(["font-size:11px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;color:", ";margin-bottom:10px;"], styleVariables.colors.gray11);
var StyledChipGrid = styled.div.withConfig({
  displayName: "filter-boardcomponent__StyledChipGrid",
  componentId: "sc-fjzdod-10"
})(["display:flex;flex-wrap:wrap;gap:7px;"]);
var StyledChip = styled.button.withConfig({
  displayName: "filter-boardcomponent__StyledChip",
  componentId: "sc-fjzdod-11"
})(["display:inline-flex;align-items:center;gap:6px;padding:5px 12px;border-radius:20px;border:1.5px solid ", ";background:", ";color:", ";font-size:12px;font-weight:", ";cursor:pointer;transition:all 0.12s ease;white-space:nowrap;&:hover{border-color:", ";color:", ";background:", ";}"], function (_ref5) {
  var $active = _ref5.$active,
      $activeBorder = _ref5.$activeBorder;
  return $active ? $activeBorder : styleVariables.colors.grey14;
}, function (_ref6) {
  var $active = _ref6.$active,
      $activeBg = _ref6.$activeBg;
  return $active ? $activeBg : '#ffffff';
}, function (_ref7) {
  var $active = _ref7.$active,
      $activeColor = _ref7.$activeColor;
  return $active ? $activeColor : styleVariables.colors.grey100;
}, function (_ref8) {
  var $active = _ref8.$active;
  return $active ? 600 : 400;
}, function (_ref9) {
  var $activeBorder = _ref9.$activeBorder;
  return $activeBorder;
}, function (_ref10) {
  var $activeColor = _ref10.$activeColor;
  return $activeColor;
}, function (_ref11) {
  var $activeBg = _ref11.$activeBg;
  return $activeBg;
});
var StyledDot = styled.span.withConfig({
  displayName: "filter-boardcomponent__StyledDot",
  componentId: "sc-fjzdod-12"
})(["width:7px;height:7px;border-radius:50%;background-color:", ";flex-shrink:0;"], function (_ref12) {
  var $color = _ref12.$color;
  return $color;
});
var StyledSectionDivider = styled.hr.withConfig({
  displayName: "filter-boardcomponent__StyledSectionDivider",
  componentId: "sc-fjzdod-13"
})(["margin:8px 16px 0;border:none;border-top:1px solid ", ";"], styleVariables.colors.grey14);
/* ── Footer ── */

var StyledPanelFooter = styled.div.withConfig({
  displayName: "filter-boardcomponent__StyledPanelFooter",
  componentId: "sc-fjzdod-14"
})(["display:flex;align-items:center;justify-content:space-between;padding:12px 16px;border-top:1px solid ", ";gap:8px;"], styleVariables.colors.grey14);
var StyledResetBtn = styled.button.withConfig({
  displayName: "filter-boardcomponent__StyledResetBtn",
  componentId: "sc-fjzdod-15"
})(["border:none;background:transparent;color:", ";font-size:13px;font-weight:500;cursor:pointer;padding:0 4px;transition:color 0.12s ease;&:hover{color:", ";}&:disabled{opacity:0.4;cursor:not-allowed;}"], styleVariables.colors.gray11, (_styleVariables$color = styleVariables.colors.red3) !== null && _styleVariables$color !== void 0 ? _styleVariables$color : '#f5222d');
var StyledApplyBtn = styled.button.withConfig({
  displayName: "filter-boardcomponent__StyledApplyBtn",
  componentId: "sc-fjzdod-16"
})(["flex:1;height:36px;border-radius:8px;border:none;background:", ";color:#ffffff;font-size:13px;font-weight:600;cursor:pointer;transition:opacity 0.12s ease;&:hover{opacity:0.88;}"], styleVariables.colors.blue3); // ─── Filter icon ──────────────────────────────────────────────────────────────

var FilterIcon = function FilterIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M1 3h13M3.5 7.5h8M6 12h3",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    })
  });
};

var CloseIcon = function CloseIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M1 1l12 12M13 1L1 13",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round"
    })
  });
}; // ─── Section renderers ────────────────────────────────────────────────────────


function StatusSection(_ref13) {
  var _draft$section$key;

  var section = _ref13.section,
      draft = _ref13.draft,
      onDraftChange = _ref13.onDraftChange;
  var currentValue = (_draft$section$key = draft[section.key]) !== null && _draft$section$key !== void 0 ? _draft$section$key : '';

  var toggle = function toggle(id) {
    onDraftChange(section.key, currentValue === id ? '' : id);
  };

  return /*#__PURE__*/_jsxs(StyledSection, {
    children: [/*#__PURE__*/_jsx(StyledSectionLabel, {
      children: section.label
    }), /*#__PURE__*/_jsx(StyledChipGrid, {
      children: section.options.map(function (opt) {
        var _STATUS_STYLE$opt$id;

        var style = (_STATUS_STYLE$opt$id = STATUS_STYLE[opt.id]) !== null && _STATUS_STYLE$opt$id !== void 0 ? _STATUS_STYLE$opt$id : FALLBACK_STYLE;
        var isActive = currentValue === opt.id;
        return /*#__PURE__*/_jsxs(StyledChip, {
          type: "button",
          $active: isActive,
          $activeBg: style.activeBg,
          $activeBorder: style.activeBorder,
          $activeColor: style.activeColor,
          onClick: function onClick() {
            return toggle(opt.id);
          },
          children: [/*#__PURE__*/_jsx(StyledDot, {
            $color: style.dot
          }), opt.label]
        }, opt.id);
      })
    })]
  });
} // ─── Main component ───────────────────────────────────────────────────────────


export var FilterBoard = function FilterBoard(_ref14) {
  var sections = _ref14.sections,
      values = _ref14.values,
      onApply = _ref14.onApply,
      onReset = _ref14.onReset,
      labels = _ref14.labels;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1]; // Draft mirrors committed values; only flushed on Apply


  var _useState2 = useState(values),
      draft = _useState2[0],
      setDraft = _useState2[1];

  var wrapperRef = useRef(null); // Sync draft when panel opens so it reflects latest committed values

  useEffect(function () {
    if (open) setDraft(values);
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  var handleBlur = function handleBlur(e) {
    var _wrapperRef$current;

    if (!((_wrapperRef$current = wrapperRef.current) !== null && _wrapperRef$current !== void 0 && _wrapperRef$current.contains(e.relatedTarget))) {
      setOpen(false);
    }
  };

  var handleDraftChange = function handleDraftChange(key, value) {
    setDraft(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, key, value));
    });
  };

  var handleApply = function handleApply() {
    onApply(draft);
    setOpen(false);
  };

  var handleReset = function handleReset() {
    var cleared = {};
    sections.forEach(function (s) {
      cleared[s.key] = '';
    });
    setDraft(cleared);
    onReset();
    setOpen(false);
  }; // Count of non-empty committed values = active filter count


  var activeCount = Object.values(values).filter(Boolean).length;
  var isDraftDirty = Object.values(draft).some(Boolean);
  return /*#__PURE__*/_jsxs(StyledWrapper, {
    ref: wrapperRef,
    onBlur: handleBlur,
    tabIndex: -1,
    children: [/*#__PURE__*/_jsxs(StyledTrigger, {
      type: "button",
      $active: activeCount > 0,
      onClick: function onClick() {
        return setOpen(function (v) {
          return !v;
        });
      },
      "aria-haspopup": "dialog",
      "aria-expanded": open,
      children: [/*#__PURE__*/_jsx(FilterIcon, {}), labels.trigger, activeCount > 0 && /*#__PURE__*/_jsx(StyledBadge, {
        children: activeCount
      })]
    }), open && /*#__PURE__*/_jsxs(StyledPanel, {
      role: "dialog",
      "aria-label": labels.trigger,
      children: [/*#__PURE__*/_jsxs(StyledPanelHeader, {
        children: [/*#__PURE__*/_jsx(StyledPanelTitle, {
          children: labels.trigger
        }), /*#__PURE__*/_jsx(StyledCloseBtn, {
          type: "button",
          onClick: function onClick() {
            return setOpen(false);
          },
          "aria-label": labels.cancel,
          children: /*#__PURE__*/_jsx(CloseIcon, {})
        })]
      }), /*#__PURE__*/_jsx(StyledPanelBody, {
        children: sections.map(function (section, idx) {
          return /*#__PURE__*/_jsxs(React.Fragment, {
            children: [section.type === 'status' && /*#__PURE__*/_jsx(StatusSection, {
              section: section,
              draft: draft,
              onDraftChange: handleDraftChange
            }), idx < sections.length - 1 && /*#__PURE__*/_jsx(StyledSectionDivider, {})]
          }, section.key);
        })
      }), /*#__PURE__*/_jsxs(StyledPanelFooter, {
        children: [/*#__PURE__*/_jsx(StyledResetBtn, {
          type: "button",
          onClick: handleReset,
          disabled: !isDraftDirty && activeCount === 0,
          children: labels.resetAll
        }), /*#__PURE__*/_jsx(StyledApplyBtn, {
          type: "button",
          onClick: handleApply,
          children: labels.apply
        })]
      })]
    })]
  });
};